module.exports = __webpack_public_path__ + "img/bsafe.ad51b822.png";